export default "__VITE_ASSET__CVnIOFa2__"